import React from "react";
import "./Footer.css";
import { ThemeContext } from "../../Context/theme";
import EmailIcon from "@material-ui/icons/Email";
import PhoneIcon from "@material-ui/icons/Phone";
export const Footer = () => {
  const [{ themename }] = React.useContext(ThemeContext);

  return (
    <>
      <div className={"section " + themename}>
        <a
          href="https://github.com/vaishali31verma"
          rel="noreferrer"
          target="_blank"
        >
         
         
        </a>
        <p className="footer"> <EmailIcon  style={{margin:"-5px 5px"}}/>Email:gadaiyavaishali31@gmail.com</p>
           <p className="footer"> <PhoneIcon style={{margin:"-5px 5px"}}/>Phone:9057293220</p>
          {/* <h3 className="footer">Made  By Vaishali Verma</h3> */}
      </div>
    </>
  );
};
